import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center mt-3" }
const _hoisted_2 = {
  class: "spinner-border text-center",
  role: "status"
}
const _hoisted_3 = { class: "visually-hidden" }


export default /*#__PURE__*/_defineComponent({
  __name: 'Loading',
  setup(__props) {

const LOADING_MESSAGE = window.gettext('Loading')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(LOADING_MESSAGE)) + "...", 1 /* TEXT */)
    ])
  ]))
}
}

})